import { Component, OnInit } from '@angular/core';
import { GfTitleService } from '../../../../services/core.title.service';
import { UiService } from '../../../../services/core.ui.service';
import { UserRest } from '../../../../services/core.user.rest.service';
import { UserService } from '../../../../services/core.user.service';
import { GfTranslateService } from '../../../../services/core.translate.service';
import { StateService } from '@uirouter/angular';

@Component({
  selector: 'change-email-confirm',
  template: require('./changeemail.confirm.component.html')
})
export class ChangeEmailConfirmComponent implements OnInit {
  public user: any;
  public status: number = -1;
  public confirming: boolean = false;
  public msg: string = '';

  constructor(
    private uiService: UiService,
    private userRest: UserRest,
    private userService: UserService,
    private translateService: GfTranslateService,
    private stateService: StateService, 
    
    private titleService: GfTitleService,
    ) {}

  ngOnInit(): void {
    // Set page title
    this.titleService.setTitle('Change Email Confirm');

    // Redirect to login if the user is not logged in
    if (!this.userService.session.hasUser()) {
      this.stateService.go('home.user.login');
      return;
    }

    this.user = this.userService.session.getUser();
    this.sendConfirm();
  }

  private sendConfirm(): void {
    this.status = -1;
    this.confirming = true;

    const params = {
      email: decodeURIComponent(this.stateService.params.email),
      token: this.stateService.params.token
    };

    this.userRest.postEmailConfirm(this.user.unixName, params)
    .then(
      () => {
        this.status = 0;
        this.msg = this.translateService.translate('Your new email has been confirmed.');
      },
      (err) => {
        this.status = 1;
        if (err?.error?.type === 'user-emailchange-token-not-exist') {
          this.msg = this.translateService.translate(
            'The email change token is expired or non existent. Please request the mail change again.'
          );
        } else {
          this.msg = this.translateService.translate('Your email change could not be confirmed.');
        }
      })
      .then(() => {
        this.confirming = false;
      });
  }
}
